import {createRouter, createWebHistory} from 'vue-router'
import store from "@/store";
import MainLayout from '@/layouts/MainLayout.vue'; // مسیر لی‌اوت اصلی
import Login from "@/views/auth/Login"; // صفحه لاگین
import SystemManagmentLogin from "@/views/auth/system_managment_login"; // صفحه لاگین
const routes = [
    // **************************************************
    // صفحات عمومی و لاگین (بدون لی‌اوت اصلی)
    // **************************************************
    {
        path: '/',
        name: 'login',
        component: Login,
        meta: {loginRedirect: true}
    },

    {
        path: '/system/managment/admin',
        name: 'SystemManagmentLogin',
        component: SystemManagmentLogin,
        meta: {loginRedirect: true}
    },

    
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: () => import("@/views/NotFoundView.vue"),
        meta: {layout: 'EmptyLayout'}
    },
    // مسیر توضیحات شغل (اگر نیاز به لی‌اوت اصلی ندارد، اینجا بماند، وگرنه به پایین منتقل کنید)
    {
        path: '/job-description/:organizationId/:step?',
        name: 'job_description',
        component: () => import("@/views/Organization/JobId/JobDescription.vue"),
    },

    // **************************************************
    // صفحات داخلی (با لی‌اوت اصلی)
    // **************************************************
    {
        path: '/',
        component: MainLayout,
        meta: {requiredAuth: true}, // تمام فرزندان نیاز به احراز هویت دارند
        children: [
            // pishkhan
            {
                path: 'pishkhan',
                name: 'home',
                component: () => import('../views/HomeView.vue'),
            },
            // default
            {
                path: 'mother_items',
                name: 'mother_items',
                component: () => import('../views/users/mother/ListMothersItems.vue'),
                meta: {is_show: () => store.state.is_show}
            },

            // --- User ---
            {
                path: 'pishkhan/list/user',
                name: 'list_user',
                component: () => import('../views/users/ListUser.vue'),
            },
            {
                path: 'pishkhan/list/user_self',
                name: 'list_user_self',
                component: () => import('../views/users/mother/ListUserSelf.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'pishkhan/list/user/by/:id/:title',
                name: 'list_user_mother',
                component: () => import('../views/users/mother/ListUserMotherById.vue'),
                meta: {is_show: () => store.state.is_show}
            },

            // --- Organization ---
            {
                path: 'pishkhan/Organization/list',
                name: 'list_organic',
                component: () => import('../views/Organization/ListOrganization.vue'),
            },
            {
                path: 'pishkhan/Organization/list/public',
                name: 'list_organic_public',
                component: () => import('../views/Organization/ListOrganizationPublicMode.vue'),
            },
            {
                path: 'pishkhan/Organization/list/Charts',
                name: 'ListOrganizationCharts',
                component: () => import('../views/Organization/ListOrganizationCharts.vue'),
            },
            {
                path: 'pishkhan/Organization/units',
                name: 'organ_units',
                component: () => import('../views/organ_units/organ_unitsView.vue'),
                meta: {is_show: () => store.state.is_show}
            },

            {
                path: 'pishkhan/Organization/types',
                name: 'organization_types',
                component: () => import('../views/Organization_types/ListOrganizationType.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'pishkhan/Organization/units/chart',
                name: 'organ_units_chart',
                component: () => import('../views/organ_units/organ_unitsChartsView.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'pishkhan/Organization/list_self',
                name: 'list_organic_self',
                component: () => import('../views/Organization/ListOrganizationSelf.vue'),
            },
            {
                path: 'pishkhan/Organization/list/by/:id/:title',
                name: 'list_organic_mother',
                component: () => import('../views/Organization/ListOrganizationById.vue'),
            },

            // --- meeting_mgmt ---
{
                path: 'sessions/list',
                name: 'sessions/list',
                component: () => import('../views/meeting_mgmt/sessions_list.vue'),
                meta: {is_show: () => store.state.is_show}
            },

            // --- Process ---
            {
                path: 'process/map',
                name: 'process_map',
                component: () => import('../views/process/process_map.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'process/map_self',
                name: 'process_map_self',
                component: () => import('../views/process/process_map_self.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'process/map/by/:id/:title',
                name: 'process_map_by_id',
                component: () => import('../views/process/process_map_by_id.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'process/map/print',
                name: 'process_map_print',
                component: () => import('../views/process/process_map_print.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'process/id',
                name: 'process_id',
                component: () => import('../views/process/proccess_id/process_list_id.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'process/id/by/:id/:title',
                name: 'process_id_by_id',
                component: () => import('../views/process/proccess_id/process_list_id_by_id.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'process/id/complete/:id',
                name: 'process_id_complete',
                component: () => import('../views/process/proccess_id/process_id.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'process/id/complete/by_mother/:id/:title',
                name: 'process_id_complete_by_mother',
                component: () => import('../views/process/proccess_id/process_id_by_mother.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Process/documentation/management',
                name: 'process_documentation_management',
                component: () => import('../views/process/process_documentation_management/process_documentation_managementView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Process/documentation/management/FolderMode',
                name: 'process_documentation_management_FolderMode',
                component: () => import('../views/process/process_documentation_management/process_documentation_managementFolderMode/process_documentation_managementFolderModeView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Process/documentation/management/FolderAndFileMode/:id',
                name: 'process_documentation_management_FolderAndFileMode',
                component: () => import('../views/process/process_documentation_management/process_documentation_managementFolderMode/process_documentation_managementFolderModeAndFileView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Process/documentation/management/by/:id/:title',
                name: 'process_documentation_management_by_id',
                component: () => import('../views/process/process_documentation_management/process_documentation_managementByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Settings ---
            {
                path: 'settings',
                name: 'settings',
                component: () => import('../views/settings/SettingsView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'settings/period_system',
                name: 'settings_period_system',
                component: () => import('../views/settings/settingsPeriodSystemView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'settings/about',
                name: 'about',
                component: () => import('../views/settings/aboutView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'settings/units',
                name: 'settings_units',
                component: () => import('../views/settings/SettingsUnitsView.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Job Evaluation ---
            {
                path: 'job/evaluation',
                name: 'job_evaluation',
                component: () => import('../views/process/evaluation/job_evaluation.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'job/evaluation/by/:id/:title',
                name: 'job_evaluation_by_id',
                component: () => import('../views/process/evaluation/job_evaluation_by_id.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'job/evaluation/by/self',
                name: 'job_evaluation_by_self',
                component: () => import('../views/process/evaluation/job_evaluation_self.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Beneficiary ---
            {
                path: 'beneficiary/map',
                name: 'beneficiary_map',
                component: () => import('../views/beneficiary/beneficiary_map.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/map/by/:id/:title',
                name: 'beneficiary_map_by_id',
                component: () => import('../views/beneficiary/beneficiary_map_by_id.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/id',
                name: 'beneficiary_id',
                component: () => import('../views/beneficiary/beneficiary_id.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary_period',
                name: 'beneficiary_period',
                component: () => import('../views/beneficiary/beneficiary_periodView.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/index',
                name: 'beneficiary_index',
                component: () => import('../views/beneficiary/beneficiary_id_by_process.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/Expertise',
                name: 'beneficiary_Expertise',
                component: () => import('../views/beneficiary/beneficiary_Expertise.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/order_by',
                name: 'beneficiary_id_order_by',
                component: () => import('../views/beneficiary/beneficiary_id_order_by.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/order_by/power',
                name: 'beneficiary_id_order_by_power',
                component: () => import('../views/beneficiary/beneficiary_id_order_by_power.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/order_by/power_for_management',
                name: 'beneficiary_id_order_by_power_for_management',
                component: () => import('../views/beneficiary/beneficiary_id_order_by_power_for_management.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/order_by/power_for_management_chart',
                name: 'beneficiary_id_order_by_power_for_management_chart',
                component: () => import('../views/beneficiary/beneficiary_id_order_by_power_for_management_chart.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/order_by/Mitchell',
                name: 'beneficiary_id_order_by_Mitchell',
                component: () => import('../views/beneficiary/beneficiary_id_order_by_Mitchell.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/order_by/mitchell_for_management',
                name: 'beneficiary_id_order_by_mitchell_for_management',
                component: () => import('../views/beneficiary/beneficiary_id_order_by_mitchell_for_management.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/order_by/mitchell_for_management_circle',
                name: 'beneficiary_id_order_by_mitchell_for_management_circle',
                component: () => import('../views/beneficiary/beneficiary_id_order_by_mitchell_for_management_circle.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary/order_by/mitchell_for_management_table',
                name: 'beneficiary_id_order_by_mitchell_for_management_table',
                component: () => import('../views/beneficiary/beneficiary_id_order_by_mitchell_for_management_table.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary_analytics',
                name: 'beneficiary_analytics',
                component: () => import('../views/beneficiary/beneficiary_analytics_index.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary_analytics_by_beneficiary',
                name: 'beneficiary_analytics_by_beneficiary',
                component: () => import('../views/beneficiary/beneficiary_analytics_index_by_beneficiary.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'beneficiary_analytics_by_process',
                name: 'beneficiary_analytics_by_process',
                component: () => import('../views/beneficiary/beneficiary_analytics_index_by_process.vue'),
                meta: {is_show: () => store.state.is_show}
            },

            // --- Financial Management and Productivity ---
            {
                path: 'Financial_management_and_productivity/definitions',
                name: 'Financial_management_and_productivity_definitions',
                component: () => import('../views/Financial_management_and_productivity/basic/definitions.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/definitions/by/:id/:title',
                name: 'Financial_management_and_productivity_definitions_by',
                component: () => import('../views/Financial_management_and_productivity/basic/definitions_by_id.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/Determining_the_mission',
                name: 'Financial_management_and_productivity_Determining_the_mission',
                component: () => import('../views/Financial_management_and_productivity/Determining_the_mission/Determining_the_mission.vue'),
            },
            {
                path: 'Financial_management_and_productivity/Determining_the_mission/By/:id/:title',
                name: 'Financial_management_and_productivity_Determining_the_missionById',
                component: () => import('../views/Financial_management_and_productivity/Determining_the_mission/Determining_the_missionById.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/FaceDefinitionFinancialSituation',
                name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation',
                component: () => import('../views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituation.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/FaceDefinitionFinancialSituation/by/:id/:title',
                name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation_by_id',
                component: () => import('../views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituationById.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/FaceDefinitionFinancialSituation/chart',
                name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation_chart',
                component: () => import('../views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituationChart.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/FaceDefinitionFinancialSituation/chart/by/:id/:title',
                name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation_chart_by_id',
                component: () => import('../views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituationChartById.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/ProfitAndLossStructure',
                name: 'Financial_management_and_productivity_ProfitAndLossStructure',
                component: () => import('../views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructure.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/ProfitAndLossStructure/by/:id/:title',
                name: 'Financial_management_and_productivity_ProfitAndLossStructure_by_id',
                component: () => import('../views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructureById.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/ProfitAndLossStructure/chart',
                name: 'Financial_management_and_productivity_ProfitAndLossStructure_chart',
                component: () => import('../views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructureChart.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/ProfitAndLossStructure/chart/by/:id/:title',
                name: 'Financial_management_and_productivity_ProfitAndLossStructure_chart_by_id',
                component: () => import('../views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructureChartById.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/TheStructureOfTheCashFlowStatement',
                name: 'Financial_management_and_productivity_TheStructureOfTheCashFlowStatement',
                component: () => import('../views/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement/TheStructureOfTheCashFlowStatement.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/TheStructureOfTheCashFlowStatement/by/:id/:title',
                name: 'Financial_management_and_productivity_TheStructureOfTheCashFlowStatement_by_id',
                component: () => import('../views/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement/TheStructureOfTheCashFlowStatementById.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/DefinitionOfOutput',
                name: 'Financial_management_and_productivity_DefinitionOfOutput',
                component: () => import('../views/Financial_management_and_productivity/DefinitionOfOutput/DefinitionOfOutput.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/DefinitionOfOutput/by/:id/:title',
                name: 'Financial_management_and_productivity_DefinitionOfOutput_by_id',
                component: () => import('../views/Financial_management_and_productivity/DefinitionOfOutput/DefinitionOfOutputById.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/DefinitionOfConsequence',
                name: 'Financial_management_and_productivity_DefinitionOfConsequence',
                component: () => import('../views/Financial_management_and_productivity/DefinitionOfConsequence/DefinitionOfConsequence.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/DefinitionOfConsequence/by/:id/:title',
                name: 'Financial_management_and_productivity_DefinitionOfConsequenceById',
                component: () => import('../views/Financial_management_and_productivity/DefinitionOfConsequence/DefinitionOfConsequenceById.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/IntermediateOutcome',
                name: 'Financial_management_and_productivity_IntermediateOutcome',
                component: () => import('../views/Financial_management_and_productivity/IntermediateOutcome/IntermediateOutcome.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/IntermediateOutcome/by/:id/:title',
                name: 'Financial_management_and_productivity_IntermediateOutcomeById',
                component: () => import('../views/Financial_management_and_productivity/IntermediateOutcome/IntermediateOutcomeById.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/DefinitionOfEffect',
                name: 'Financial_management_and_productivity_DefinitionOfEffect',
                component: () => import('../views/Financial_management_and_productivity/DefinitionOfEffect/DefinitionOfEffect.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/DefinitionOfEffect/by/:id/:title',
                name: 'Financial_management_and_productivity_DefinitionOfEffectById',
                component: () => import('../views/Financial_management_and_productivity/DefinitionOfEffect/DefinitionOfEffectById.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/plan-management',
                name: 'Financial_management_and_productivity_plan_management',
                component: () => import('../views/Financial_management_and_productivity/PlanManagement'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/data-center',
                name: 'Financial_management_and_productivity_data_center',
                component: () => import('../views/Financial_management_and_productivity/DataCenter'),
                meta: {is_show: () => store.state.is_show}
            },
            
            // Functional Information
            {
                path: 'Financial_management_and_productivity/functional_information',
                name: 'Financial_management_and_productivity_functional_information',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/functional_informationView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/by/:id/:title',
                name: 'Financial_management_and_productivity_functional_informationById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/functional_informationByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/Financial',
                name: 'Financial_management_and_productivity_functional_information_Financial',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_FinancialView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/Financial/by/:id/:title',
                name: 'Financial_management_and_productivity_functional_information_FinancialById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_FinancialByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/received',
                name: 'Financial_management_and_productivity_functional_information_received',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_receivedView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/received/by/:id/:title',
                name: 'Financial_management_and_productivity_functional_information_received_by_id',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_receivedByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/Consequences',
                name: 'Financial_management_and_productivity_functional_information_Consequences',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_ConsequencesView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/Consequences/by/:id/:title',
                name: 'Financial_management_and_productivity_functional_information_ConsequencesById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_ConsequencesByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/Consequences/middle',
                name: 'Financial_management_and_productivity_functional_information_Consequences_middle',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_Consequences_middleView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/Consequences/middle/by/:id/:title',
                name: 'Financial_management_and_productivity_functional_information_Consequences_middle_by_id',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_Consequences_middleByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/effect',
                name: 'Financial_management_and_productivity_functional_information_effect',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_effectView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/effect/by/:id/:title',
                name: 'Financial_management_and_productivity_functional_information_effectById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_effectByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/wealths',
                name: 'Financial_management_and_productivity_functional_information_wealths',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_wealths.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/wealths/by/:id/:title',
                name: 'Financial_management_and_productivity_functional_information_wealthsById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_wealthsById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/debts',
                name: 'Financial_management_and_productivity_functional_information_debts',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_debts.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/debts/by/:id/:title',
                name: 'Financial_management_and_productivity_functional_information_debtsById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_debtsById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/profit_and_loss_structures',
                name: 'Financial_management_and_productivity_functional_information_profitAndLossStructures',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_profitAndLossStructures.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/profit_and_loss_structures/by/:id/:title',
                name: 'Financial_management_and_productivity_functional_information_profitAndLossStructuresById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_profitAndLossStructuresById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/cashes',
                name: 'Financial_management_and_productivity_functional_information_cashes',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_cashes.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/cashes/by/:id/:title',
                name: 'Financial_management_and_productivity_functional_information_cashesById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_cashesById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/plan-management',
                name: 'Financial_management_and_productivity_functional_information_plan_management',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/PlanManagement'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/functional_information/labor',
                name: 'Financial_management_and_productivity_functional_information_labor',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/Labor'),
                meta: {is_show: () => store.state.is_show},
            },

            // Budget Information
            {
                path: 'Financial_management_and_productivity/budget_information',
                name: 'Financial_management_and_productivity_budget_information',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/budget_informationView.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/budget_information/by/:id/:title',
                name: 'Financial_management_and_productivity_budget_informationById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/budget_informationByIdView.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'Financial_management_and_productivity/budget_information/Financial',
                name: 'Financial_management_and_productivity_budget_information_Financial',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_FinancialView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/Financial/by/:id/:title',
                name: 'Financial_management_and_productivity_budget_information_FinancialById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_FinancialByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/received',
                name: 'Financial_management_and_productivity_budget_information_received',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_receivedView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/received/by/:id/:title',
                name: 'Financial_management_and_productivity_budget_information_receivedById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_receivedByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/Consequences',
                name: 'Financial_management_and_productivity_budget_information_Consequences',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_ConsequencesView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/Consequences/by/:id/:title',
                name: 'Financial_management_and_productivity_budget_information_ConsequencesById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_ConsequencesByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/Consequences/middle',
                name: 'Financial_management_and_productivity_budget_information_Consequences_middle',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_Consequences_middleView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/Consequences/middle/by/:id/:title',
                name: 'Financial_management_and_productivity_budget_information_Consequences_middleById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_Consequences_middleByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/effect',
                name: 'Financial_management_and_productivity_budget_information_effect',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_effectView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/effect/by/:id/:title',
                name: 'Financial_management_and_productivity_budget_information_effectById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_effectByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/wealths',
                name: 'Financial_management_and_productivity_budget_information_wealths',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_wealths.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/wealths/by/:id/:title',
                name: 'Financial_management_and_productivity_budget_information_wealthsById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_wealthsById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/debts',
                name: 'Financial_management_and_productivity_budget_information_debts',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_debts.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/debts/by/:id/:title',
                name: 'Financial_management_and_productivity_budget_information_debtsById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_debtsById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/profit_and_loss_structures',
                name: 'Financial_management_and_productivity_budget_information_profitAndLossStructures',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_profitAndLossStructures.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/profit_and_loss_structures/by/:id/:title',
                name: 'Financial_management_and_productivity_budget_information_profitAndLossStructuresById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_profitAndLossStructuresById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/cashes',
                name: 'Financial_management_and_productivity_budget_information_cashes',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_cashes.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/budget_information/cashes/by/:id/:title',
                name: 'Financial_management_and_productivity_budget_information_cashesById',
                component: () => import('../views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_cashesById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            
            // Define Adjustment Coefficients
            {
                path: 'Financial_management_and_productivity/define-adjustment-coefficients',
                name: 'Financial_management_and_productivity_define_adjustment_coefficients',
                component: () => import('../views/Financial_management_and_productivity/DefineAdjustmentCoefficients/index.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/define-adjustment-coefficients/material',
                name: 'Financial_management_and_productivity_define_adjustment_coefficients_material',
                component: () => import('../views/Financial_management_and_productivity/DefineAdjustmentCoefficients/MaterialAdjustmentCoefficients/index.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/define-adjustment-coefficients/products',
                name: 'Financial_management_and_productivity_define_adjustment_coefficients_products',
                component: () => import('../views/Financial_management_and_productivity/DefineAdjustmentCoefficients/ProductsAdjustmentCoefficients/index.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Financial_management_and_productivity/define-adjustment-coefficients/energy',
                name: 'Financial_management_and_productivity_define_adjustment_coefficients_energy',
                component: () => import('../views/Financial_management_and_productivity/DefineAdjustmentCoefficients/EnergyAdjustmentCoefficients/index.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            // Define Productivity Representations
            {
                path: 'Financial_management_and_productivity/define-productivity-representations',
                name: 'Financial_management_and_productivity_define_productivity_representations',
                component: () => import('../views/Financial_management_and_productivity/DefineProductivityRepresentations/index.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            // Materials Definition
            {
                path: 'Financial_management_and_productivity/materials-definition',
                name: 'Financial_management_and_productivity_materials_definition',
                component: () => import('../views/Financial_management_and_productivity/MaterialsDefinition/index.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            // Products Definition
            {
                path: 'Financial_management_and_productivity/products-definition',
                name: 'Financial_management_and_productivity_products_definition',
                component: () => import('../views/Financial_management_and_productivity/ProductsDefinition/index.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            // Energy Definition
            {
                path: 'Financial_management_and_productivity/energy-definition',
                name: 'Financial_management_and_productivity_energy_definition',
                component: () => import('../views/Financial_management_and_productivity/EnergyDefinition/index.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Problem Analysis ---
            {
                path: 'problem_analysis/Problem_identification',
                name: 'problem_analysis_Problem_identification',
                component: () => import('../views/problem_analysis/Problem_identification/Problem_identification.vue'),
            },
            {
                path: 'problem_analysis/Problem_identification/by/:id/:title',
                name: 'problem_analysis_Problem_identificationById',
                component: () => import('../views/problem_analysis/Problem_identification/Problem_identificationById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'problem_analysis/Prioritizing_issue',
                name: 'problem_analysis_Prioritizing_issue',
                component: () => import('../views/problem_analysis/Prioritizing_issue/Prioritizing_issue.vue'),
            },
            {
                path: 'problem_analysis/Prioritizing_issue/by/:id/:title',
                name: 'problem_analysis_Prioritizing_issueById',
                component: () => import('../views/problem_analysis/Prioritizing_issue/Prioritizing_issueById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'problem_analysis/The_root_causes_of_the_problem',
                name: 'problem_analysis_The_root_causes_of_the_problem',
                component: () => import('../views/problem_analysis/The_root_causes_of_the_problem/The_root_causes_of_the_problem.vue'),
            },
            {
                path: 'problem_analysis/The_root_causes_of_the_problem/by/:id/:title',
                name: 'problem_analysis_The_root_causes_of_the_problemById',
                component: () => import('../views/problem_analysis/The_root_causes_of_the_problem/The_root_causes_of_the_problemById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'problem_analysis/Definition_of_basic_measures',
                name: 'problem_analysis_Definition_of_basic_measures',
                component: () => import('../views/problem_analysis/Definition_of_basic_measures/Definition_of_basic_measures.vue'),
            },
            {
                path: 'problem_analysis/Definition_of_basic_measures/by/:id/:title',
                name: 'problem_analysis_Definition_of_basic_measuresById',
                component: () => import('../views/problem_analysis/Definition_of_basic_measures/mother/Definition_of_basic_measuresById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'problem_analysis/Definition_of_basic_measures/SupportMeasures',
                name: 'problem_analysis_Definition_of_basic_measures_SupportMeasures',
                component: () => import('../views/problem_analysis/Definition_of_basic_measures/Definition_of_basic_measures_SupportMeasures.vue'),
            },
            {
                path: 'problem_analysis/Definition_of_basic_measures/SupportMeasures/by/:id/:title',
                name: 'problem_analysis_Definition_of_basic_measures_SupportMeasuresById',
                component: () => import('../views/problem_analysis/Definition_of_basic_measures/mother/Definition_of_basic_measures_SupportMeasuresById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'problem_analysis/device_monitoring_and_care',
                name: 'problem_analysis_device_monitoring_and_care',
                component: () => import('../views/problem_analysis/device_monitoring_and_care/device_monitoring_and_care.vue'),
            },

            {
                path: 'performance/dashboard',
                name: 'performance_dashboard',
                component: () => import('../views/PerformanceManagement/dashboard/dashboard.vue'),
            },
            {
                path: 'problem_analysis/device_monitoring_and_care/by/:id/:title',
                name: 'problem_analysis_device_monitoring_and_careById',
                component: () => import('../views/problem_analysis/device_monitoring_and_care/device_monitoring_and_careById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'problem_analysis/device_monitoring_and_care/by/backup/:id/:title',
                name: 'problem_analysis_device_monitoring_and_careById_backup',
                component: () => import('../views/problem_analysis/device_monitoring_and_care_backup/device_monitoring_and_care_backup_ById.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'problem_analysis/device_monitoring_and_care/backup_action',
                name: 'problem_analysis_device_monitoring_and_care_backup_action',
                component: () => import('../views/problem_analysis/device_monitoring_and_care_backup/device_monitoring_and_care_backup.vue'),
            },
            {
                path: '/Impact_Assessment',
                name: 'Impact_Assessment',
                component: () => import('../views/problem_analysis/Impact_Assessment/Impact_Assessment.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: '/Impact_Assessment/by/:id/:title',
                name: 'Impact_Assessment_by',
                component: () => import('../views/problem_analysis/Impact_Assessment/Impact_Assessment_by.vue'),
                meta: {is_show: () => store.state.is_show}
            },

            // --- Design and Modeling ---
            {
                path: 'Design_and_modeling',
                name: 'Design_and_modeling',
                component: () => import('../views/process/Design_and_modeling/Design_and_modelingView.vue'),
                meta: {is_show: () => store.state.is_show},
            },


             {
                path: 'systems/list',
                name: 'systems/list',
                component: () => import('../views/systems/systemsListView.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Matrix Connections ---
            {
                path: 'Matrix_Connections',
                name: 'Matrix_Connections',
                component: () => import('../views/Matrix_Connections/indexMatrixView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Matrix_Connections/by/:id/:title',
                name: 'Matrix_Connections_by',
                component: () => import('../views/Matrix_Connections_mother/indexMatrixMotherView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Matrix_Connections/include',
                name: 'Matrix_Connections_include',
                component: () => import('../views/Matrix_Connections/Matrix_Connections_include.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Matrix_Connections/include/by/:title/:id',
                name: 'Matrix_Connections_include_by_mother_item',
                component: () => import('../views/Matrix_Connections_mother/Matrix_Connections_includeMother.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Matrix_Connections/include/by/:type',
                name: 'Matrix_Connections_include_by',
                component: () => import('../views/Matrix_Connections/includes/Matrix_Connections_includeBy.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Matrix_Connections/include/by/:type/:title/:id',
                name: 'Matrix_Connections_include_by_mother_include',
                component: () => import('../views/Matrix_Connections_mother/includes/Matrix_Connections_includeByMother.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Matrix_Connections/exit',
                name: 'Matrix_Connections_exit',
                component: () => import('../views/Matrix_Connections/Matrix_Connections_exit.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Matrix_Connections/exit/by/:title/:id',
                name: 'Matrix_Connections_exit_by_mother_item',
                component: () => import('../views/Matrix_Connections_mother/Matrix_Connections_exitMother.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Matrix_Connections/exit/by/:type',
                name: 'Matrix_Connections_exit_by',
                component: () => import('../views/Matrix_Connections/exits/Matrix_Connections_exitBy.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Matrix_Connections/exit/by/:type/:title/:id',
                name: 'Matrix_Connections_exit_by_mother_exit',
                component: () => import('../views/Matrix_Connections_mother/exits/Matrix_Connections_exitByMother.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Roles and Responsibilities ---
            {
                path: 'RolesAndResponsibilities',
                name: 'RolesAndResponsibilities',
                component: () => import('../views/RolesAndResponsibilities/RolesAndResponsibilitiesView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'RolesAndResponsibilities/by/:id/:title',
                name: 'RolesAndResponsibilities_by_id',
                component: () => import('../views/RolesAndResponsibilities/RolesAndResponsibilitiesByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Productivity Period ---
            {
                path: 'Productivity_period',
                name: 'Productivity_period',
                component: () => import('../views/settings/Productivity_period/Productivity_periodView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Productivity_period_circle',
                name: 'Productivity_period_circle',
                component: () => import('../views/settings/Productivity_period/Productivity_periodView.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Strategic Management ---
            {
                path: 'strategicManagement/basic_defined',
                name: 'strategicManagement_basic_defined',
                component: () => import('../views/strategic_managment/default/basic_defined_strategic_management.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'strategicManagement/basic_defined_strategic_management_mother/:id/:title',
                name: 'basic_defined_strategic_management_mother',
                component: () => import('../views/strategic_managment/mother/basic_defined_strategic_management_mother.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Strategic_readiness_assessment',
                name: 'Strategic_readiness_assessment',
                component: () => import('../views/strategic_managment/default/Strategic_readiness_assessment.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            {
                path: 'balanced_scorecard',
                name: 'balanced_scorecard',
                component: () => import('../views/strategic_managment/default/balanced_scorecard.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            {
                path: 'internal_evaluation',
                name: 'internal_evaluation',
                component: () => import('../views/strategic_managment/default/internal_evaluation/internal_evaluation.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            {
                path: '5m',
                name: '5m',
                component: () => import('../views/strategic_managment/default/5_m/5m.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            {
                path: 'strategic_monitoring',
                name: 'strategic_monitoring',
                component: () => import('../views/strategic_managment/default/strategic_monitoring.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'strategic_planning',
                name: 'strategic_planning',
                component: () => import('../views/strategic_managment/default/strategic_planning.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Strategic_current',
                name: 'Strategic_current',
                component: () => import('../views/strategic_managment/default/Strategic_current.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Strategic_relations',
                name: 'Strategic_relations',
                component: () => import('../views/strategic_managment/default/Strategic_relations.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Vision_working_group',
                name: 'Vision_working_group',
                component: () => import('../views/strategic_managment/default/Vision_working_group/Vision_working_group.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Vision_working_group_Questions',
                name: 'Vision_working_group_Questions',
                component: () => import('../views/strategic_managment/default/Vision_working_group/Vision_working_group_Questions.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Vision_working_group_Suggested_perspective',
                name: 'Vision_working_group_Suggested_perspective',
                component: () => import('../views/strategic_managment/default/Vision_working_group/Vision_working_group_Suggested_perspective.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Vision_working_group_Gary_Hamel_questionnaire/ByType',
                name: 'Vision_working_group_Gary_Hamel_questionnaireByType',
                component: () => import('../views/strategic_managment/default/Vision_working_group/Vision_working_group_Gary_Hamel_questionnaireIndexByType.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'Vision_working_group_future',
                name: 'Vision_working_group_future',
                component: () => import('../views/strategic_managment/default/Vision_working_group/Vision_working_group_future.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'executive_elements',
                name: 'executive_elements',
                component: () => import('../views/strategic_managment/default/executive_elements/executive_elementsView.vue'),
            },
            {
                path: 'executive_elements/by/:id/:title',
                name: 'executive_elements_by_id',
                component: () => import('../views/strategic_managment/mother/executive_elements/executive_elementsByIdView.vue'),
            },
            {
                path: 'executive_elements/chart',
                name: 'executive_elements_chart',
                component: () => import('../views/strategic_managment/default/executive_elements/executive_elementsChartView.vue'),
            },
            {
                path: 'executive_elements/chart/by/:id/:title',
                name: 'executive_elements_chart_by_id',
                component: () => import('../views/strategic_managment/mother/executive_elements/executive_elementsChartByIdView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'executive_elements/habits/:id/:name',
                name: 'executive_elements_habits',
                component: () => import('../views/strategic_managment/default/executive_elements/executive_elements_habitsView.vue'),
            },
            {
                path: '5_f/intro',
                name: '5_f',
                component: () => import('../views/5_f/fiveFView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: '5_f/step_1',
                name: '5_f_step_one',
                component: () => import('../views/5_f/fiveF_step_OneView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: '5_f/step_2',
                name: '5_f_step_two',
                component: () => import('../views/5_f/fiveF_step_TwoView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'pestel',
                name: 'pestel',
                component: () => import('../views/strategic_managment/default/pestel/pestel_main.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'pestel_step_1',
                name: 'pestel_step_one',
                component: () => import('../views/strategic_managment/default/pestel/pestel_step_one.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'pestel_step_2',
                name: 'pestel_step_two',
                component: () => import('../views/strategic_managment/default/pestel/pestel_step_two.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'pestel_matrices_efe',
                name: 'pestel_matrices_efe',
                component: () => import('../views/strategic_managment/default/pestel/pestel_matrices_efe.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'pestel_matrices_attractiveness',
                name: 'pestel_matrices_attractiveness',
                component: () => import('../views/strategic_managment/default/pestel/pestel_matrices_attractiveness.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Tickets ---
            {
                path: 'ticket',
                name: 'ticket',
                component: () => import('../views/tickets/ticketView.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'ticket/detail/:id',
                name: 'ticket_detail',
                component: () => import('../views/tickets/ticketDetailView.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Performance Management ---
            {
                path: 'performance-management/economic-operation-report',
                name: 'performance_management_economic_operation_report',
                component: () => import('../views/PerformanceManagement/EconomicOperationReport/index.vue'),
                meta: {is_show: () => store.state.is_show}
            },
            {
                path: 'performance-management/economic-operation-report/holdings/kaveh-pars',
                name: 'performance_management_economic_operation_report_holdings_kaveh_pars',
                component: () => import('../views/PerformanceManagement/EconomicOperationReport/KavehPars/index.vue'),
                meta: {is_show: () => store.state.is_show}
            },

            // --- Productivity Improvement Program ---
            {
                path: 'productivity_improvement_program',
                name: 'productivity_improvement_program',
                component: () => import('../views/planning_and _monitoring _the_efficiency_of_government_services/productivity_improvement_program.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            {
                path: 'monitoring_improvement_program',
                name: 'monitoring_improvement_program',
                component: () => import('../views/planning_and _monitoring _the_efficiency_of_government_services/monitoring_improvement_program.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'productivity_improvement_program/by/:id/:title',
                name: 'productivity_improvement_program_by',
                component: () => import('../views/planning_and _monitoring _the_efficiency_of_government_services/mother/productivity_improvement_program.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Risk Management ---
            {
                path: 'risk-management/risk-planning',
                name: 'risk_management.risk_planning',
                component: () => import('@/views/RiskManagement/RiskPlanning'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'risk-management/risk-planning/risk-charter',
                name: 'risk_management.risk_planning.risk_charter',
                component: () => import('@/views/RiskManagement/RiskPlanning/RiskCharter'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'risk-management/risk-planning/risk-policy',
                name: 'risk_management.risk_planning.risk_policy',
                component: () => import('@/views/RiskManagement/RiskPlanning/RiskPolicy'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'risk-management/risk-planning/risk-statement/:step?',
                name: 'risk_management.risk_planning.risk_statement',
                component: () => import('@/views/RiskManagement/RiskPlanning/RiskStatement'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'risk-management/risk-planning/risk-statement/risk-components/risk-description/:id?',
                name: 'risk_management.risk_planning.risk_statement.risk_components.risk_description',
                component: () => import('@/views/RiskManagement/RiskPlanning/RiskStatement/RiskDescription.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'risk-management/risk-planning/risk-statement/business-rules/:id?',
                name: 'risk_management.risk_planning.risk_statement.business_rules',
                component: () => import('@/views/RiskManagement/RiskPlanning/RiskStatement/RiskTypeDetail.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'risk-management/risk-planning/risk-statement/risk-appetite/:id?',
                name: 'risk_management.risk_planning.risk_statement.risk_appetite',
                component: () => import('@/views/RiskManagement/RiskPlanning/RiskStatement/RiskAppetite.vue'),
                meta: {is_show: () => store.state.is_show},
            },

            // --- Strategic Planning ---
            {
                path: 'strategic-planning/general-success-factors/:organizationId/:step?',
                name: 'strategic_planning.general_success',
                component: () => import('@/views/StrategicPlanning/GeneralSuccessFactors.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'strategic-planning/cpm/:organizationId/:step?',
                name: 'strategic_planning.cpm',
                component: () => import('@/views/StrategicPlanning/CPM.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'strategic-planning/rbv/:organizationId/:step?',
                name: 'strategic_planning.rbv',
                component: () => import('@/views/StrategicPlanning/RBV/index.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'strategic-planning/rbv/exist/:organizationId/:step?',
                name: 'strategic_planning.rbv.exist',
                component: () => import('@/views/StrategicPlanning/RBV/ExistRBV.vue'),
                meta: {is_show: () => store.state.is_show},
            },
            {
                path: 'strategic-planning/rbv/non-exist/:organizationId/:step?',
                name: 'strategic_planning.rbv.non_exist',
                component: () => import('@/views/StrategicPlanning/RBV/NonExistRBV.vue'),
                meta: {is_show: () => store.state.is_show},
            },

             {
                path: 'User_activity_reports',
                name: 'User_activity_reports',
                component: () => import('../views/reports/mother/ListLogs.vue'),
                meta: {is_show: () => store.state.is_show}
            },

            {
                path: 'reports/processes',
                name: 'reports/processes',
                component: () => import('../views/reports/mother/reportsProcesses.vue'),
                meta: {is_show: () => store.state.is_show}
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// Navigation Guard
router.beforeEach(async (to, from, next) => {
    // 1. بررسی اینکه آیا کاربر از قبل لاگین است یا خیر
    // اگر قبلاً لاگین بوده، نیازی به درخواست مجدد نیست
    if (!store.state.isAuth) {
        try {
            // 2. اگر لاگین نیست، وضعیت را از سرور چک کن
            await store.dispatch('checkLoginStatus')
        } catch (error) {
            console.error("Error checking login status:", error)
            // در صورت خطا، فرض را بر عدم احراز هویت بگذار
            store.commit('setAuthStatus', { // فرض کنید این mutation وجود دارد یا از متد دیگری استفاده کنید
                isAuth: false,
                mother_mode: false,
                is_mother: 0,
                is_process_manager: false,
                id_login: ''
            })
        }
    }

    // 3. بررسی is_show برای مسیر فعلی
    const isShowForRoute = to.matched.some(record => {
        const isShowValue = typeof record.meta.is_show === 'function'
            ? record.meta.is_show()
            : record.meta.is_show
        return isShowValue === false
    })

    if (isShowForRoute) {
        // اگر مسیر نباید نمایش داده شود، به داشبورد یا صفحه دیگری ریدایرکت کن
        next('/pishkhan')
        return
    }

    // 4. بررسی احراز هویت مورد نیاز
    if (to.matched.some(record => record.meta.requiredAuth)) {
        if (store.state.isAuth) {
            next() // اجازه ورود
        } else {
            next('/') // یا next('/login') بسته به نیاز شما
        }
    } else if (to.matched.some(record => record.meta.loginRedirect)) {
        if (!store.state.isAuth) {
            next() // اجازه ورود اگر نیاز به لاگین نیست
        } else {
            next('/pishkhan') // اگر لاگین است، به داشبورد بفرست
        }
    } else {
        next() // در غیر این صورت، اجازه عبور بده
    }
})

export default router